export default __webpack_public_path__ + "static/media/contact-page-image.d19214d6.png";